import React, { useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { 
  FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, 
  FaPaperPlane, FaCheckCircle, FaGoogle, 
  FaLinkedin, FaTwitter, FaFacebook, FaInstagram,
  FaUser, FaBuilding, FaComments
} from 'react-icons/fa';
import { 
  SiMicrosoftexcel, SiMicrosoftword, SiMicrosoftpowerpoint,
  SiAdobe, SiGoogledocs, SiGooglesheets
} from 'react-icons/si';
import './contactus.css';


import { db } from '../FirebaseComp/firebase'; // Adjust path to your Firebase config
import { collection, addDoc } from 'firebase/firestore';
import emailjs from 'emailjs-com';


// Reusable animated section component
function AnimatedSection({ children, className }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-10% 0px" });

  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.7 }}
    >
      {children}
    </motion.div>
  );
}



















function ContactUs() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    service: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  
  try {
    // 1. Save to Firebase
    const docRef = await addDoc(collection(db, "contactus"), {
      ...formData,
      timestamp: new Date(),
    });
    console.log("Document written with ID: ", docRef.id);

    // 2. Send email via EmailJS
    const emailParams = {
      from_name: formData.name,
      from_email: formData.email,
      company: formData.company,
      service: formData.service,
      message: formData.message,
      to_email: "info@glaxmore.com", // Your receiving email
    };

    await emailjs.send(
      'service_bawnqow',     
      'template_liogeq5',    
      emailParams,
      'cSfjqw_IvUvKX0QFz'      
    );

    console.log('Form submitted and email sent:', formData);
    setIsSubmitted(true);
    
    // Reset form after a delay
    setTimeout(() => {
      setFormData({ name: '', email: '', company: '', service: '', message: '' });
      setIsSubmitted(false);
    }, 5000);
  } catch (error) {
    console.error("Error submitting form:", error);
    alert("There was an error submitting your form. Please try again.");
  } finally {
    setIsLoading(false);
  }
};








  const contactMethods = [
{
  icon: <FaPhone className="glax-method-icon-svg" />,
  title: 'Call Us',
  details: ['+94 70 1111 735', '+94 76 5610 017'],
  link: ['tel:+94701111735', 'tel:+94765610017'],
  description: 'Available 24/7 for urgent inquiries'
},
{
  icon: <FaEnvelope className="glax-method-icon-svg" />,
  title: 'Email Us',
  details: ['info@glaxmore.com', 'support@glaxmore.com'],
  link: ['mailto:info@glaxmore.com', 'mailto:support@glaxmore.com'],
  description: 'We respond within 24 hours'
},

    {
      icon: <FaMapMarkerAlt className="glax-method-icon-svg" />,
      title: 'Visit Us',
      details: ['33, Sri Dharmarama Road', 'Ratmalana, Sri Lanka'],
      link: 'https://maps.google.com/?q=33,Sri+Dharmarama+Road,Ratmalana,Sri+Lanka',
      description: 'Open 24 hours for scheduled appointments'
    },
    {
      icon: <FaClock className="glax-method-icon-svg" />,
      title: 'Business Hours',
      details: ['24/7 Support Available', 'Office Hours: 8:00 AM - 6:00 PM'],
      link: null,
      description: 'We\'re always here to help'
    }
  ];

  const services = [
    "Custom Software Development",
    "Cloud Solutions & Migration",
    "AI & Machine Learning",
    "Cybersecurity Services",
    "IT Consulting",
    "Digital Transformation",
    "Other"
  ];

  return (
    <div className="glax-contact-container">
      {/* ===== HERO HEADER ===== */}
      <section className="glax-contact-hero">
        <motion.div 
          className="glax-contact-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2>Let's Start Something <span className="glax-gradient-text">Remarkable</span></h2>
          <p className="glax-hero-subtitle">
            Have an idea? Let's shape it together. Our team of experts is ready to transform your vision into reality with cutting edge IT solutions.
          </p>
        </motion.div>
        <motion.div 
          className="glax-contact-hero-graphic"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          <div className="glax-contact-graphic">
            <div className="glax-floating-element glax-element-1">
              <FaComments className="glax-floating-icon" />
            </div>
            <div className="glax-floating-element glax-element-2">
              <FaPhone className="glax-floating-icon" />
            </div>
            <div className="glax-floating-element glax-element-3">
              <FaEnvelope className="glax-floating-icon" />
            </div>
            <div className="glax-floating-element glax-element-4">
              <FaMapMarkerAlt className="glax-floating-icon" />
            </div>
            <div className="glax-main-circle">
              <div className="glax-inner-circle">
                <FaPaperPlane className="glax-contact-main-icon" />
                <span>Contact</span>
              </div>
            </div>
          </div>
        </motion.div>
      </section>

      {/* ===== MAIN CONTENT ===== */}
      <div className="glax-contact-content">
        {/* ===== CONTACT FORM ===== */}
        <AnimatedSection className="glax-contact-form-section">
          <div className="glax-form-container">
            <h2>Send Us a Message</h2>
            <p className="glax-section-subtitle">Fill out the form below and our team will get back to you shortly</p>
            
            {isSubmitted ? (
              <motion.div 
                className="glax-success-message"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
              >
                <div className="glax-success-icon">
                  <FaCheckCircle />
                </div>
                <h3>Message Received!</h3>
                <p>Thank you for contacting GLAXMORE. We'll get back to you within 24 hours.</p>
              </motion.div>
            ) : (
              <form onSubmit={handleSubmit} className="glax-contact-form">
                <div className="glax-form-grid">
                  <div className="glax-input-group">
                    <label htmlFor="name">
                      <FaUser className="glax-input-icon" />
                      Your Name *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Enter your full name"
                    />
                  </div>
                  
                  <div className="glax-input-group">
                    <label htmlFor="email">
                      <FaEnvelope className="glax-input-icon" />
                      Email Address *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="email@example.com"
                    />
                  </div>
                  
                  <div className="glax-input-group">
                    <label htmlFor="company">
                      <FaBuilding className="glax-input-icon" />
                      Company (Optional)
                    </label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      placeholder="Your company name"
                    />
                  </div>
                  
                  <div className="glax-input-group">
                    <label htmlFor="service">
                      <FaComments className="glax-input-icon" />
                      Service Interested In *
                    </label>
                    <select 
                      id="service" 
                      name="service" 
                      value={formData.service}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select a service</option>
                      {services.map((service, index) => (
                        <option key={index} value={service.toLowerCase().replace(/\s+/g, '-')}>
                          {service}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                
                <div className="glax-input-group glax-full-width">
                  <label htmlFor="message">
                    <FaPaperPlane className="glax-input-icon" />
                    Your Message *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    placeholder="Tell us about your project or inquiry..."
                  ></textarea>
                </div>
                
                <motion.button 
                  type="submit"
                  className="glax-btn glax-btn-primary glax-submit-btn"
                  whileHover={{ scale: 1.02, boxShadow: "0 10px 25px rgba(37, 99, 235, 0.3)" }}
                  whileTap={{ scale: 0.98 }}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <div className="glax-loading-spinner">
                      <div className="glax-spinner"></div>
                      Sending...
                    </div>
                  ) : (
                    <>
                      <FaPaperPlane className="glax-btn-icon" />
                      Send Message
                    </>
                  )}
                </motion.button>
              </form>
            )}
          </div>
        </AnimatedSection>

        {/* ===== CONTACT METHODS ===== */}
        <AnimatedSection className="glax-contact-methods">
          <h2>Other Ways to Connect</h2>
          <p className="glax-section-subtitle">Reach out to us through any of these channels</p>
          <div className="glax-methods-grid">
            {contactMethods.map((method, index) => (
              method.link ? (
                <motion.a 
                  key={index}
                  href={method.link}
                  className="glax-method-card"
                  whileHover={{ y: -5 }}
                  transition={{ type: "spring", stiffness: 300 }}
                  target={method.link.includes('http') ? '_blank' : '_self'}
                  rel={method.link.includes('http') ? 'noopener noreferrer' : ''}
                >
                  <div className="glax-method-icon">{method.icon}</div>
                  <h3>{method.title}</h3>
                  {method.details.map((detail, i) => (
                    <p key={i} className="glax-method-detail">{detail}</p>
                  ))}
                  <p className="glax-method-description">{method.description}</p>
                </motion.a>
              ) : (
                <motion.div 
                  key={index}
                  className="glax-method-card"
                  whileHover={{ y: -5 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  <div className="glax-method-icon">{method.icon}</div>
                  <h3>{method.title}</h3>
                  {method.details.map((detail, i) => (
                    <p key={i} className="glax-method-detail">{detail}</p>
                  ))}
                  <p className="glax-method-description">{method.description}</p>
                </motion.div>
              )
            ))}
          </div>
        </AnimatedSection>
      </div>

      {/* ===== MAP SECTION ===== */}
      <AnimatedSection className="glax-map-section">
        <h2>Find Us Here</h2>
        <p className="glax-section-subtitle">Visit our office at Ratmalana for a consultation</p>
        <div className="glax-map-container">
          <div className="glax-map-placeholder">
            <div className="glax-map-content">
              <div className="glax-pin">
                <FaMapMarkerAlt />
              </div>
              <h3>GLAXMORE IT</h3>
              <p>33, Sri Dharmarama Road</p>
              <p>Ratmalana, Sri Lanka</p>
              <a 
                href="https://maps.google.com/?q=33,Sri+Dharmarama+Road,Ratmalana,Sri+Lanka" 
                target="_blank" 
                rel="noopener noreferrer"
                className="glax-map-link"
              >
                <FaGoogle className="glax-map-link-icon" />
                Open in Google Maps
              </a>
            </div>
          </div>
        </div>
      </AnimatedSection>

      {/* ===== CTA SECTION ===== */}
      <AnimatedSection className="glax-contact-cta">
        <h2>Ready to Transform Your Business?</h2>
        <p>Schedule a free consultation with our experts today</p>
<a href="tel:+94701111735" style={{ textDecoration: "none" }}>
  <motion.button
    className="glax-btn glax-btn-primary"
    whileHover={{ scale: 1.05, boxShadow: "0 10px 25px rgba(37, 99, 235, 0.3)" }}
    whileTap={{ scale: 0.95 }}
  >
    <FaPhone className="glax-btn-icon" />&nbsp;
    Schedule a Meeting
  </motion.button>
</a>


      </AnimatedSection>
    </div>
  );
}

export default ContactUs;